(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["1-main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-split"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHeroSplitHeadlineRotators(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var rotators = scope.querySelectorAll('.hero-split__heading-line--rotator:not([data-rotator-ready])');

      rotators.forEach(function (el) {
        el.setAttribute('data-rotator-ready', 'true');

        var phrases = [
          el.getAttribute('data-phrase-1') || '',
          el.getAttribute('data-phrase-2') || '',
          el.getAttribute('data-phrase-3') || '',
          el.getAttribute('data-phrase-4') || ''
        ]
          .map(function (phrase) {
            return phrase.trim();
          })
          .filter(function (phrase) {
            return phrase.length > 0;
          });

        if (phrases.length === 0) return;

        // Show the first phrase immediately so there is never a flash of empty text.
        el.textContent = phrases[0];

        if (phrases.length === 1) return;

        var prefersReducedMotion =
          window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (prefersReducedMotion) return;

        var TYPE_SPEED = 55;
        var DELETE_SPEED = 30;
        var PAUSE_FULL = 1800;
        var PAUSE_EMPTY = 300;

        var phraseIndex = 0;
        var charIndex = phrases[0].length;
        var mode = 'pause-full';

        function tick() {
          if (mode === 'pause-full') {
            mode = 'deleting';
            setTimeout(tick, DELETE_SPEED);
            return;
          }

          if (mode === 'deleting') {
            var current = phrases[phraseIndex];
            if (charIndex > 0) {
              charIndex -= 1;
              el.textContent = current.slice(0, charIndex);
              setTimeout(tick, DELETE_SPEED);
            } else {
              phraseIndex = (phraseIndex + 1) % phrases.length;
              mode = 'pause-empty';
              setTimeout(tick, PAUSE_EMPTY);
            }
            return;
          }

          if (mode === 'pause-empty') {
            mode = 'typing';
            setTimeout(tick, TYPE_SPEED);
            return;
          }

          if (mode === 'typing') {
            var next = phrases[phraseIndex];
            if (charIndex < next.length) {
              charIndex += 1;
              el.textContent = next.slice(0, charIndex);
              setTimeout(tick, TYPE_SPEED);
            } else {
              mode = 'pause-full';
              setTimeout(tick, PAUSE_FULL);
            }
          }
        }

        setTimeout(tick, PAUSE_FULL);
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      initHeroSplitHeadlineRotators(document);
    });
    document.addEventListener('shopify:section:load', function (event) {
      initHeroSplitHeadlineRotators(event.target);
    });

    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      initHeroSplitHeadlineRotators(document);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
